module.exports = __webpack_public_path__ + "static/media/package-plus.5e01c200.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/package-plus.svg
// module id = 124
// module chunks = 0